// @ts-nocheck
export default {
  SHIPPING_TABLE_STATE_SET: 'SHIPPING/TABLE_STATE_SET',
  SHIPPING_TABLE_STATE_RESET: 'SHIPPING/TABLE_STATE_RESET',
};
